import axios from 'axios';
export class TrackedFileLinkReporter {
    static report(conf) {
        axios.post(conf.apiUrl, Object.assign(Object.assign({}, conf), { apiUrl: undefined }));
    }
}
